/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentType({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/AppointmentType"
  
}) {
let eventBorderLeftColorValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'borderLeftColor',
})
let eventBgColorValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'bgColor',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventAppointmentTypeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment_type',
})
  return (<React.Fragment
>
<div
  data-testid="AppointmentType.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AppointmentType.Vertical:1"
  data-view-path={viewPath}
 style={{'--blc-1-20SjNp': eventBorderLeftColorValueData,'--blw-2-20SjNp': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-3-20SjNp': eventBgColorValueData}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingTop="6px"
 paddingLeft="6px"
 data="event.appointment_type"
 text={eventAppointmentTypeValueData}
 weight="medium"
 size="tiny"
/>
</div>
</div>
{children}
</React.Fragment>)
}